/**
 * @file 页面信息相关定义
 */

export const defaultTitle = 'NiuLink - 简单高效的雾计算平台'
export const titleSuffix = ' - NiuLink'
